import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

interface registerfield {
  email: string
  password1: string
  password2: string
  full_name: string
}

export const signupUser: any = createAsyncThunk('users/signupUser', async (payload: registerfield, thunkAPI) => {
  try {
    const response: any = await axios.post(`${process.env.REACT_APP_API_URL}user/registration/`, payload, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })

    if (response.status === 200) {
      return response.data
    }
    return thunkAPI.rejectWithValue(response)
  } catch (e: any) {
    return thunkAPI.rejectWithValue(e.response.data)
  }
})

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    fullname: '',
    email: '',
    password: '',
    confirmpassword: '',
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
    emailError: '',
  },
  reducers: {
    clearState: (state) => {
      state.errorMessage = ''
      state.emailError = ''
    },
  },
  extraReducers: {
    [signupUser.fulfilled]: (state, { payload }): any => {
      state.isFetching = false
      state.isSuccess = true
      state.email = payload.data.email
      state.fullname = payload.data.full_name
    },
    [signupUser.pending]: (state) => {
      state.isFetching = true
    },
    [signupUser.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      if (payload?.email) {
        state.emailError = payload?.email[0]
      }
      if (payload?.details) {
        state.errorMessage = payload?.details
      }
    },
  },
})
export const userSelector = (state) => state.authUser
export const { clearState } = userSlice.actions
export default userSlice.reducer
